import graphql__86f61f6d742ec96f771a from "./__generated__/CalendarResourceItem_event.graphql.js";import { useCallback, useMemo } from "react";
import { graphql, useFragment } from "react-relay";
import { List } from "rsuite";

import { useFormatDate, useFormatTime, useFormatMessage } from "../Intl/Context";
import { useDateRangeMessage } from "../Utils/dateRangeMessage";

const CalendarResourceItem = ({ ...props }) => {
  const event = useFragment(CalendarResourceItem_event, props.event);
  const { title, url, startsAt, endsAt } = event;
  const color = event.color;

  const t = useFormatMessage();
  const formatDate = useFormatDate();
  const formatTime = useFormatTime();

  const startDate = useMemo(() => new Date(startsAt), [startsAt]);
  const endDate = useMemo(() => new Date(endsAt || startsAt), [endsAt, startsAt]);
  const isSameDay = startDate.toDateString() === endDate.toDateString();

  const startDateLabel = formatDate(startDate, {
    weekday: "long",
    day: "numeric",
    month: "long"
  });
  const startDateTimeLabel = formatTime(startDate);
  const endDateTimeLabel = formatTime(endDate);

  const oneDayEventTitle = useCallback(() => {
    const fromTo = t(intlMessages.fromTo, {
      start: startDateTimeLabel,
      end: endDateTimeLabel
    });
    const at = t(intlMessages.at, { time: startDateTimeLabel });

    // If there's no actual end time filled in the event, we just display the start time
    const duration = endsAt ? fromTo : at;

    return (
      <p>
        {startDateLabel} {duration}
      </p>
    );
  }, [endDateTimeLabel, endsAt, startDateLabel, startDateTimeLabel, t]);

  const multipleDaysEventTitle = useCallback(() => {
    const endDateLabel = formatDate(endDate, {
      weekday: "long",
      day: "numeric",
      month: "long"
    });

    const from = t(intlMessages.from, { date: startDateLabel, time: startDateTimeLabel });
    const to = t(intlMessages.to, { date: endDateLabel, time: endDateTimeLabel });

    return (
      <p>
        {from} {to}
      </p>
    );
  }, [endDate, endDateTimeLabel, formatDate, startDateLabel, startDateTimeLabel, t]);

  const formatDateRange = useDateRangeMessage();

  const eventDate = useMemo(() => {
    if (event.eventMode) {
      return isSameDay ? oneDayEventTitle() : multipleDaysEventTitle();
    } else {
      return formatDateRange(startsAt, endsAt);
    }
  }, [
    endsAt,
    event.eventMode,
    formatDateRange,
    isSameDay,
    multipleDaysEventTitle,
    oneDayEventTitle,
    startsAt
  ]);

  return (
    <List.Item className="calendar-event">
      <a href={url} className="calendar-event-link">
        <div className="calendar-event-header">{eventDate}</div>

        <div className="calendar-event-body">
          <div className="item-color-marker" style={{ backgroundColor: color }} />
          <div className="item-content">
            <div className="item-title">{title}</div>
          </div>
        </div>
      </a>
    </List.Item>
  );
};

const CalendarResourceItem_event = graphql__86f61f6d742ec96f771a;

export default CalendarResourceItem;

const intlMessages = {
  fromTo: {
    id: "calendar.list.item.fromTo",
    defaultMessage: "de {start} à {end}"
  },
  at: {
    id: "calendar.list.item.at",
    defaultMessage: "à {time}"
  },
  from: {
    id: "calendar.list.item.from",
    defaultMessage: "Du {date} à {time}"
  },
  to: {
    id: "calendar.list.item.to",
    defaultMessage: "au {date} à {time}"
  }
};
